import React, { useState } from 'react';
import { Box, Grommet } from 'grommet';
import HeaderExample from './Header';
import Contact from './Contact';
import theme from './theme';
import SignIn from './SignIn';
import Feed from './Feed';
import UploadView from './Upload/UploadView';
import About from './About';
import MenuLayer from './MenuLayer';
import doe from './profiles/doe';
import MyFiles from './MyFiles';
import Analytics from './Analytics';

function App() {
  const [ view, setView ] = useState('analytics');
  const [ loggedIn, setLoggedIn ] = useState(true);
  const [ showMenuLayer, setShowMenuLayer ] = useState(false);
  const [ user, setUser ] = useState(doe)

  return (
    <Grommet theme={theme} themeMode="dark" full>
      <Box margin='auto' fill>
        <HeaderExample
          setView={setView}
          loggedIn={loggedIn}
          setLoggedIn={setLoggedIn}
          setShowMenuLayer={setShowMenuLayer}
          user={user}
        />
        { view === 'feed' && <Feed /> }
        { view === 'contact' && <Contact setView={setView}/> }
        { view === 'signIn' && (
          <SignIn
            setLoggedIn={setLoggedIn}
            setView={setView}
            setUser={setUser}
          />
        )}
        { view === 'upload' && <UploadView user={user}/>}
        { view === 'about' && <About />}
        { view === 'myFiles' && <MyFiles user={user}/>}
        { view === 'analytics' && <Analytics />}
        { showMenuLayer  && (
          <MenuLayer
            setShowMenuLayer={setShowMenuLayer}
            setView={setView}
            setLoggedIn={setLoggedIn}
            loggedIn={loggedIn}
            user={user}
          />
        )}
      </Box>
    </Grommet>
  );
}

export default App;
